var jt = Object.defineProperty;
var Ht = (e, t, n) => t in e ? jt(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var M = (e, t, n) => Ht(e, typeof t != "symbol" ? t + "" : t, n);
import { reactive as z, provide as ht, onMounted as Dt, inject as ft, getCurrentInstance as Y } from "vue";
import { A as _, g as E, R as H, M as dt, B as O, k as S, D as J, l as Ft, p as It, m as N, C as gt, n as zt } from "./maps.ChaVcqWI.js";
var D = /* @__PURE__ */ ((e) => (e.Active = "active", e.Sending = "sending", e.Success = "success", e.Failure = "failure", e))(D || {});
const Pt = [
  _.SendForm,
  _.SendSaveSearch,
  _.SendSubscribe
], Lt = [
  // TODO: add empty click here and update button component
  _.ApplyDiscount,
  _.OpenUri,
  _.OpenBookingEngine,
  _.NoAction,
  _.Dismiss
], Ot = [
  _.Hide
];
class Nt {
  constructor() {
    M(this, "dataValidators", {});
    M(this, "state", z({
      actions: [],
      buttonState: D.Active,
      stepActive: E.Main,
      stepPrevious: null,
      isFirstStep: !0,
      hideFunction: () => {
      }
    }));
  }
  get buttonState() {
    return this.state.buttonState;
  }
  get isFirstStep() {
    return this.state.isFirstStep;
  }
  get stepActive() {
    return this.state.stepActive;
  }
  get stepPrevious() {
    return this.state.stepPrevious;
  }
  initialize(t, n) {
    this.state.hideFunction = t, this.state.actions = n;
  }
  setStepActive(t, n = null) {
    this.state.stepActive = t, this.state.isFirstStep = t === E.Main, this.state.stepPrevious = n;
  }
  setDataValidator(t, n) {
    this.dataValidators[t] = n;
  }
  // accep type as generic for return
  async callHandler(t, n) {
    if (!this.state.actions) return !1;
    let r = {};
    const a = this.dataValidators[t];
    if (a && (r = await a(), !r))
      return !1;
    let i;
    const s = [
      // Some handlers will never come with a moduleId as they do not belong to any content module (dismiss, show..)
      (o) => o.kind === t,
      // Last hope, look for the None action - the default one
      (o) => o.kind === _.Fallback
    ];
    n && s.unshift((o) => o.moduleId === n);
    for (let o = 0; !i && o < s.length; o += 1)
      i = this.state.actions.find(s[o]);
    if (!i) return !1;
    let u = !1;
    return i.handler && (this.state.buttonState = D.Sending, u = await i.handler(r), this.state.buttonState = D.Active), Pt.includes(t) && (this.state.stepActive = u ? E.Success : E.Failure, this.state.isFirstStep = !1), Lt.includes(t) && this.callHandler(_.Hide), Ot.includes(t) && this.state.hideFunction(), u;
  }
  goBackToMainStep() {
    this.state.stepPrevious = this.state.stepActive, this.state.stepActive = E.Main, this.state.isFirstStep = !0;
  }
  reset() {
    this.state.buttonState = D.Active, this.state.stepActive = E.Main, this.state.isFirstStep = !0;
  }
}
function U(e) {
  "@babel/helpers - typeof";
  return U = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, U(e);
}
var Bt = /^\s+/, Vt = /\s+$/;
function l(e, t) {
  if (e = e || "", t = t || {}, e instanceof l)
    return e;
  if (!(this instanceof l))
    return new l(e, t);
  var n = Ut(e);
  this._originalInput = e, this._r = n.r, this._g = n.g, this._b = n.b, this._a = n.a, this._roundA = Math.round(100 * this._a) / 100, this._format = t.format || n.format, this._gradientType = t.gradientType, this._r < 1 && (this._r = Math.round(this._r)), this._g < 1 && (this._g = Math.round(this._g)), this._b < 1 && (this._b = Math.round(this._b)), this._ok = n.ok;
}
l.prototype = {
  isDark: function() {
    return this.getBrightness() < 128;
  },
  isLight: function() {
    return !this.isDark();
  },
  isValid: function() {
    return this._ok;
  },
  getOriginalInput: function() {
    return this._originalInput;
  },
  getFormat: function() {
    return this._format;
  },
  getAlpha: function() {
    return this._a;
  },
  getBrightness: function() {
    var t = this.toRgb();
    return (t.r * 299 + t.g * 587 + t.b * 114) / 1e3;
  },
  getLuminance: function() {
    var t = this.toRgb(), n, r, a, i, s, u;
    return n = t.r / 255, r = t.g / 255, a = t.b / 255, n <= 0.03928 ? i = n / 12.92 : i = Math.pow((n + 0.055) / 1.055, 2.4), r <= 0.03928 ? s = r / 12.92 : s = Math.pow((r + 0.055) / 1.055, 2.4), a <= 0.03928 ? u = a / 12.92 : u = Math.pow((a + 0.055) / 1.055, 2.4), 0.2126 * i + 0.7152 * s + 0.0722 * u;
  },
  setAlpha: function(t) {
    return this._a = xt(t), this._roundA = Math.round(100 * this._a) / 100, this;
  },
  toHsv: function() {
    var t = mt(this._r, this._g, this._b);
    return {
      h: t.h * 360,
      s: t.s,
      v: t.v,
      a: this._a
    };
  },
  toHsvString: function() {
    var t = mt(this._r, this._g, this._b), n = Math.round(t.h * 360), r = Math.round(t.s * 100), a = Math.round(t.v * 100);
    return this._a == 1 ? "hsv(" + n + ", " + r + "%, " + a + "%)" : "hsva(" + n + ", " + r + "%, " + a + "%, " + this._roundA + ")";
  },
  toHsl: function() {
    var t = pt(this._r, this._g, this._b);
    return {
      h: t.h * 360,
      s: t.s,
      l: t.l,
      a: this._a
    };
  },
  toHslString: function() {
    var t = pt(this._r, this._g, this._b), n = Math.round(t.h * 360), r = Math.round(t.s * 100), a = Math.round(t.l * 100);
    return this._a == 1 ? "hsl(" + n + ", " + r + "%, " + a + "%)" : "hsla(" + n + ", " + r + "%, " + a + "%, " + this._roundA + ")";
  },
  toHex: function(t) {
    return bt(this._r, this._g, this._b, t);
  },
  toHexString: function(t) {
    return "#" + this.toHex(t);
  },
  toHex8: function(t) {
    return Zt(this._r, this._g, this._b, this._a, t);
  },
  toHex8String: function(t) {
    return "#" + this.toHex8(t);
  },
  toRgb: function() {
    return {
      r: Math.round(this._r),
      g: Math.round(this._g),
      b: Math.round(this._b),
      a: this._a
    };
  },
  toRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
  },
  toPercentageRgb: function() {
    return {
      r: Math.round(g(this._r, 255) * 100) + "%",
      g: Math.round(g(this._g, 255) * 100) + "%",
      b: Math.round(g(this._b, 255) * 100) + "%",
      a: this._a
    };
  },
  toPercentageRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(g(this._r, 255) * 100) + "%, " + Math.round(g(this._g, 255) * 100) + "%, " + Math.round(g(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(g(this._r, 255) * 100) + "%, " + Math.round(g(this._g, 255) * 100) + "%, " + Math.round(g(this._b, 255) * 100) + "%, " + this._roundA + ")";
  },
  toName: function() {
    return this._a === 0 ? "transparent" : this._a < 1 ? !1 : se[bt(this._r, this._g, this._b, !0)] || !1;
  },
  toFilter: function(t) {
    var n = "#" + vt(this._r, this._g, this._b, this._a), r = n, a = this._gradientType ? "GradientType = 1, " : "";
    if (t) {
      var i = l(t);
      r = "#" + vt(i._r, i._g, i._b, i._a);
    }
    return "progid:DXImageTransform.Microsoft.gradient(" + a + "startColorstr=" + n + ",endColorstr=" + r + ")";
  },
  toString: function(t) {
    var n = !!t;
    t = t || this._format;
    var r = !1, a = this._a < 1 && this._a >= 0, i = !n && a && (t === "hex" || t === "hex6" || t === "hex3" || t === "hex4" || t === "hex8" || t === "name");
    return i ? t === "name" && this._a === 0 ? this.toName() : this.toRgbString() : (t === "rgb" && (r = this.toRgbString()), t === "prgb" && (r = this.toPercentageRgbString()), (t === "hex" || t === "hex6") && (r = this.toHexString()), t === "hex3" && (r = this.toHexString(!0)), t === "hex4" && (r = this.toHex8String(!0)), t === "hex8" && (r = this.toHex8String()), t === "name" && (r = this.toName()), t === "hsl" && (r = this.toHslString()), t === "hsv" && (r = this.toHsvString()), r || this.toHexString());
  },
  clone: function() {
    return l(this.toString());
  },
  _applyModification: function(t, n) {
    var r = t.apply(null, [this].concat([].slice.call(n)));
    return this._r = r._r, this._g = r._g, this._b = r._b, this.setAlpha(r._a), this;
  },
  lighten: function() {
    return this._applyModification(Qt, arguments);
  },
  brighten: function() {
    return this._applyModification(Yt, arguments);
  },
  darken: function() {
    return this._applyModification(te, arguments);
  },
  desaturate: function() {
    return this._applyModification(Kt, arguments);
  },
  saturate: function() {
    return this._applyModification(Wt, arguments);
  },
  greyscale: function() {
    return this._applyModification(Jt, arguments);
  },
  spin: function() {
    return this._applyModification(ee, arguments);
  },
  _applyCombination: function(t, n) {
    return t.apply(null, [this].concat([].slice.call(n)));
  },
  analogous: function() {
    return this._applyCombination(ae, arguments);
  },
  complement: function() {
    return this._applyCombination(ne, arguments);
  },
  monochromatic: function() {
    return this._applyCombination(ie, arguments);
  },
  splitcomplement: function() {
    return this._applyCombination(re, arguments);
  },
  // Disabled until https://github.com/bgrins/TinyColor/issues/254
  // polyad: function (number) {
  //   return this._applyCombination(polyad, [number]);
  // },
  triad: function() {
    return this._applyCombination(yt, [3]);
  },
  tetrad: function() {
    return this._applyCombination(yt, [4]);
  }
};
l.fromRatio = function(e, t) {
  if (U(e) == "object") {
    var n = {};
    for (var r in e)
      e.hasOwnProperty(r) && (r === "a" ? n[r] = e[r] : n[r] = F(e[r]));
    e = n;
  }
  return l(e, t);
};
function Ut(e) {
  var t = {
    r: 0,
    g: 0,
    b: 0
  }, n = 1, r = null, a = null, i = null, s = !1, u = !1;
  return typeof e == "string" && (e = ce(e)), U(e) == "object" && (A(e.r) && A(e.g) && A(e.b) ? (t = qt(e.r, e.g, e.b), s = !0, u = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : A(e.h) && A(e.s) && A(e.v) ? (r = F(e.s), a = F(e.v), t = Xt(e.h, r, a), s = !0, u = "hsv") : A(e.h) && A(e.s) && A(e.l) && (r = F(e.s), i = F(e.l), t = Gt(e.h, r, i), s = !0, u = "hsl"), e.hasOwnProperty("a") && (n = e.a)), n = xt(n), {
    ok: s,
    format: e.format || u,
    r: Math.min(255, Math.max(t.r, 0)),
    g: Math.min(255, Math.max(t.g, 0)),
    b: Math.min(255, Math.max(t.b, 0)),
    a: n
  };
}
function qt(e, t, n) {
  return {
    r: g(e, 255) * 255,
    g: g(t, 255) * 255,
    b: g(n, 255) * 255
  };
}
function pt(e, t, n) {
  e = g(e, 255), t = g(t, 255), n = g(n, 255);
  var r = Math.max(e, t, n), a = Math.min(e, t, n), i, s, u = (r + a) / 2;
  if (r == a)
    i = s = 0;
  else {
    var o = r - a;
    switch (s = u > 0.5 ? o / (2 - r - a) : o / (r + a), r) {
      case e:
        i = (t - n) / o + (t < n ? 6 : 0);
        break;
      case t:
        i = (n - e) / o + 2;
        break;
      case n:
        i = (e - t) / o + 4;
        break;
    }
    i /= 6;
  }
  return {
    h: i,
    s,
    l: u
  };
}
function Gt(e, t, n) {
  var r, a, i;
  e = g(e, 360), t = g(t, 100), n = g(n, 100);
  function s(f, h, c) {
    return c < 0 && (c += 1), c > 1 && (c -= 1), c < 1 / 6 ? f + (h - f) * 6 * c : c < 1 / 2 ? h : c < 2 / 3 ? f + (h - f) * (2 / 3 - c) * 6 : f;
  }
  if (t === 0)
    r = a = i = n;
  else {
    var u = n < 0.5 ? n * (1 + t) : n + t - n * t, o = 2 * n - u;
    r = s(o, u, e + 1 / 3), a = s(o, u, e), i = s(o, u, e - 1 / 3);
  }
  return {
    r: r * 255,
    g: a * 255,
    b: i * 255
  };
}
function mt(e, t, n) {
  e = g(e, 255), t = g(t, 255), n = g(n, 255);
  var r = Math.max(e, t, n), a = Math.min(e, t, n), i, s, u = r, o = r - a;
  if (s = r === 0 ? 0 : o / r, r == a)
    i = 0;
  else {
    switch (r) {
      case e:
        i = (t - n) / o + (t < n ? 6 : 0);
        break;
      case t:
        i = (n - e) / o + 2;
        break;
      case n:
        i = (e - t) / o + 4;
        break;
    }
    i /= 6;
  }
  return {
    h: i,
    s,
    v: u
  };
}
function Xt(e, t, n) {
  e = g(e, 360) * 6, t = g(t, 100), n = g(n, 100);
  var r = Math.floor(e), a = e - r, i = n * (1 - t), s = n * (1 - a * t), u = n * (1 - (1 - a) * t), o = r % 6, f = [n, s, i, i, u, n][o], h = [u, n, n, s, i, i][o], c = [i, i, u, n, n, s][o];
  return {
    r: f * 255,
    g: h * 255,
    b: c * 255
  };
}
function bt(e, t, n, r) {
  var a = [w(Math.round(e).toString(16)), w(Math.round(t).toString(16)), w(Math.round(n).toString(16))];
  return r && a[0].charAt(0) == a[0].charAt(1) && a[1].charAt(0) == a[1].charAt(1) && a[2].charAt(0) == a[2].charAt(1) ? a[0].charAt(0) + a[1].charAt(0) + a[2].charAt(0) : a.join("");
}
function Zt(e, t, n, r, a) {
  var i = [w(Math.round(e).toString(16)), w(Math.round(t).toString(16)), w(Math.round(n).toString(16)), w(At(r))];
  return a && i[0].charAt(0) == i[0].charAt(1) && i[1].charAt(0) == i[1].charAt(1) && i[2].charAt(0) == i[2].charAt(1) && i[3].charAt(0) == i[3].charAt(1) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) + i[3].charAt(0) : i.join("");
}
function vt(e, t, n, r) {
  var a = [w(At(r)), w(Math.round(e).toString(16)), w(Math.round(t).toString(16)), w(Math.round(n).toString(16))];
  return a.join("");
}
l.equals = function(e, t) {
  return !e || !t ? !1 : l(e).toRgbString() == l(t).toRgbString();
};
l.random = function() {
  return l.fromRatio({
    r: Math.random(),
    g: Math.random(),
    b: Math.random()
  });
};
function Kt(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = l(e).toHsl();
  return n.s -= t / 100, n.s = G(n.s), l(n);
}
function Wt(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = l(e).toHsl();
  return n.s += t / 100, n.s = G(n.s), l(n);
}
function Jt(e) {
  return l(e).desaturate(100);
}
function Qt(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = l(e).toHsl();
  return n.l += t / 100, n.l = G(n.l), l(n);
}
function Yt(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = l(e).toRgb();
  return n.r = Math.max(0, Math.min(255, n.r - Math.round(255 * -(t / 100)))), n.g = Math.max(0, Math.min(255, n.g - Math.round(255 * -(t / 100)))), n.b = Math.max(0, Math.min(255, n.b - Math.round(255 * -(t / 100)))), l(n);
}
function te(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = l(e).toHsl();
  return n.l -= t / 100, n.l = G(n.l), l(n);
}
function ee(e, t) {
  var n = l(e).toHsl(), r = (n.h + t) % 360;
  return n.h = r < 0 ? 360 + r : r, l(n);
}
function ne(e) {
  var t = l(e).toHsl();
  return t.h = (t.h + 180) % 360, l(t);
}
function yt(e, t) {
  if (isNaN(t) || t <= 0)
    throw new Error("Argument to polyad must be a positive number");
  for (var n = l(e).toHsl(), r = [l(e)], a = 360 / t, i = 1; i < t; i++)
    r.push(l({
      h: (n.h + i * a) % 360,
      s: n.s,
      l: n.l
    }));
  return r;
}
function re(e) {
  var t = l(e).toHsl(), n = t.h;
  return [l(e), l({
    h: (n + 72) % 360,
    s: t.s,
    l: t.l
  }), l({
    h: (n + 216) % 360,
    s: t.s,
    l: t.l
  })];
}
function ae(e, t, n) {
  t = t || 6, n = n || 30;
  var r = l(e).toHsl(), a = 360 / n, i = [l(e)];
  for (r.h = (r.h - (a * t >> 1) + 720) % 360; --t; )
    r.h = (r.h + a) % 360, i.push(l(r));
  return i;
}
function ie(e, t) {
  t = t || 6;
  for (var n = l(e).toHsv(), r = n.h, a = n.s, i = n.v, s = [], u = 1 / t; t--; )
    s.push(l({
      h: r,
      s: a,
      v: i
    })), i = (i + u) % 1;
  return s;
}
l.mix = function(e, t, n) {
  n = n === 0 ? 0 : n || 50;
  var r = l(e).toRgb(), a = l(t).toRgb(), i = n / 100, s = {
    r: (a.r - r.r) * i + r.r,
    g: (a.g - r.g) * i + r.g,
    b: (a.b - r.b) * i + r.b,
    a: (a.a - r.a) * i + r.a
  };
  return l(s);
};
l.readability = function(e, t) {
  var n = l(e), r = l(t);
  return (Math.max(n.getLuminance(), r.getLuminance()) + 0.05) / (Math.min(n.getLuminance(), r.getLuminance()) + 0.05);
};
l.isReadable = function(e, t, n) {
  var r = l.readability(e, t), a, i;
  switch (i = !1, a = he(n), a.level + a.size) {
    case "AAsmall":
    case "AAAlarge":
      i = r >= 4.5;
      break;
    case "AAlarge":
      i = r >= 3;
      break;
    case "AAAsmall":
      i = r >= 7;
      break;
  }
  return i;
};
l.mostReadable = function(e, t, n) {
  var r = null, a = 0, i, s, u, o;
  n = n || {}, s = n.includeFallbackColors, u = n.level, o = n.size;
  for (var f = 0; f < t.length; f++)
    i = l.readability(e, t[f]), i > a && (a = i, r = l(t[f]));
  return l.isReadable(e, r, {
    level: u,
    size: o
  }) || !s ? r : (n.includeFallbackColors = !1, l.mostReadable(e, ["#fff", "#000"], n));
};
var Q = l.names = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "0ff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "00f",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  burntsienna: "ea7e5d",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "0ff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "f0f",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "663399",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
}, se = l.hexNames = oe(Q);
function oe(e) {
  var t = {};
  for (var n in e)
    e.hasOwnProperty(n) && (t[e[n]] = n);
  return t;
}
function xt(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function g(e, t) {
  ue(e) && (e = "100%");
  var n = le(e);
  return e = Math.min(t, Math.max(0, parseFloat(e))), n && (e = parseInt(e * t, 10) / 100), Math.abs(e - t) < 1e-6 ? 1 : e % t / parseFloat(t);
}
function G(e) {
  return Math.min(1, Math.max(0, e));
}
function v(e) {
  return parseInt(e, 16);
}
function ue(e) {
  return typeof e == "string" && e.indexOf(".") != -1 && parseFloat(e) === 1;
}
function le(e) {
  return typeof e == "string" && e.indexOf("%") != -1;
}
function w(e) {
  return e.length == 1 ? "0" + e : "" + e;
}
function F(e) {
  return e <= 1 && (e = e * 100 + "%"), e;
}
function At(e) {
  return Math.round(parseFloat(e) * 255).toString(16);
}
function _t(e) {
  return v(e) / 255;
}
var y = function() {
  var e = "[-\\+]?\\d+%?", t = "[-\\+]?\\d*\\.\\d+%?", n = "(?:" + t + ")|(?:" + e + ")", r = "[\\s|\\(]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")\\s*\\)?", a = "[\\s|\\(]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")\\s*\\)?";
  return {
    CSS_UNIT: new RegExp(n),
    rgb: new RegExp("rgb" + r),
    rgba: new RegExp("rgba" + a),
    hsl: new RegExp("hsl" + r),
    hsla: new RegExp("hsla" + a),
    hsv: new RegExp("hsv" + r),
    hsva: new RegExp("hsva" + a),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
  };
}();
function A(e) {
  return !!y.CSS_UNIT.exec(e);
}
function ce(e) {
  e = e.replace(Bt, "").replace(Vt, "").toLowerCase();
  var t = !1;
  if (Q[e])
    e = Q[e], t = !0;
  else if (e == "transparent")
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0,
      format: "name"
    };
  var n;
  return (n = y.rgb.exec(e)) ? {
    r: n[1],
    g: n[2],
    b: n[3]
  } : (n = y.rgba.exec(e)) ? {
    r: n[1],
    g: n[2],
    b: n[3],
    a: n[4]
  } : (n = y.hsl.exec(e)) ? {
    h: n[1],
    s: n[2],
    l: n[3]
  } : (n = y.hsla.exec(e)) ? {
    h: n[1],
    s: n[2],
    l: n[3],
    a: n[4]
  } : (n = y.hsv.exec(e)) ? {
    h: n[1],
    s: n[2],
    v: n[3]
  } : (n = y.hsva.exec(e)) ? {
    h: n[1],
    s: n[2],
    v: n[3],
    a: n[4]
  } : (n = y.hex8.exec(e)) ? {
    r: v(n[1]),
    g: v(n[2]),
    b: v(n[3]),
    a: _t(n[4]),
    format: t ? "name" : "hex8"
  } : (n = y.hex6.exec(e)) ? {
    r: v(n[1]),
    g: v(n[2]),
    b: v(n[3]),
    format: t ? "name" : "hex"
  } : (n = y.hex4.exec(e)) ? {
    r: v(n[1] + "" + n[1]),
    g: v(n[2] + "" + n[2]),
    b: v(n[3] + "" + n[3]),
    a: _t(n[4] + "" + n[4]),
    format: t ? "name" : "hex8"
  } : (n = y.hex3.exec(e)) ? {
    r: v(n[1] + "" + n[1]),
    g: v(n[2] + "" + n[2]),
    b: v(n[3] + "" + n[3]),
    format: t ? "name" : "hex"
  } : !1;
}
function he(e) {
  var t, n;
  return e = e || {
    level: "AA",
    size: "small"
  }, t = (e.level || "AA").toUpperCase(), n = (e.size || "small").toLowerCase(), t !== "AA" && t !== "AAA" && (t = "AA"), n !== "small" && n !== "large" && (n = "small"), {
    level: t,
    size: n
  };
}
function fe(e, t = 1) {
  let n = e.replace("#", "");
  if (![3, 6].includes(n.length))
    return null;
  n.length === 3 && (n = n.split("").map((a) => a + a).join(""));
  const r = parseInt(n, 16);
  return `rgba(${r >> 16 & 255},${r >> 8 & 255},${r & 255},${t})`;
}
function en(e) {
  const t = e.replace(/[-_\s]+(.)?/g, (n, r) => r ? r.toUpperCase() : "");
  return t.substring(0, 1).toUpperCase() + t.substring(1);
}
function wt(e) {
  return e.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase();
}
const nn = (e) => e.replace(/[A-Z]/g, (t) => `_${t.toLowerCase()}`);
function de(e) {
  switch ((e == null ? void 0 : e.kind) || H.Rounded) {
    case H.Custom:
      const n = e;
      return `${n.value}${n.format}`;
    case H.Square:
      return "0px";
    case H.Medium:
      return "6px";
    case H.Rounded:
    default:
      return "16px";
  }
}
function ge(e = 0) {
  return `${e}px`;
}
function rn(e = 0) {
  return `${e}%`;
}
function an(e = 0) {
  return `${e}em`;
}
function B(e) {
  return `${e * 6 / 100}em`;
}
function pe({
  format: e,
  top: t,
  right: n,
  bottom: r,
  left: a
}) {
  switch (e) {
    case dt.Pixels:
      return `${t}${e} ${n}${e} ${r}${e} ${a}${e}`;
    case dt.Em:
    default:
      return `${B(t)} ${B(n)} ${B(r)} ${B(a)}`;
  }
}
function me(e) {
  return (e == null ? void 0 : e.constructor) === Object;
}
function V(e, t = 2) {
  return e.toFixed(0).padStart(t, "0");
}
function sn(e) {
  if (e < 0)
    return {
      hours: "00",
      minutes: "00",
      seconds: "00"
    };
  const t = Math.floor(e / 60), n = Math.floor(t / 60), r = Math.floor(n / 24), a = {
    // Warn: order of key-values of the object *is* critical for display
    days: V(r),
    hours: V(n % 24),
    minutes: V(t % 60),
    seconds: V(e % 60)
  };
  return r ? delete a.seconds : delete a.days, a;
}
function on(e) {
  if (!e) return "";
  const t = document.createElement("div");
  return t.innerHTML = e, t.textContent || t.innerText;
}
var T = {};
Object.defineProperty(T, "__esModule", { value: !0 });
T.TokenData = void 0;
T.parse = X;
T.compile = xe;
T.match = ke;
T.pathToRegexp = $e;
const be = "/", tt = (e) => e, ve = new RegExp("^\\p{XID_Continue}$", "u"), I = "https://git.new/pathToRegexpError", ye = {
  "!": "!",
  "@": "@",
  ";": ";",
  ",": ",",
  "*": "*",
  "+": "+",
  "?": "?",
  "{": "{",
  "}": "}"
};
function _e(e) {
  const t = [...e], n = [];
  let r = 0;
  for (; r < t.length; ) {
    const a = t[r], i = ye[a];
    if (i) {
      n.push({ type: i, index: r++, value: a });
      continue;
    }
    if (a === "\\") {
      n.push({ type: "ESCAPED", index: r++, value: t[r++] });
      continue;
    }
    if (a === ":") {
      let s = "";
      for (; ve.test(t[++r]); )
        s += t[r];
      if (!s)
        throw new TypeError(`Missing parameter name at ${r}`);
      n.push({ type: "NAME", index: r, value: s });
      continue;
    }
    if (a === "(") {
      const s = r++;
      let u = 1, o = "";
      if (t[r] === "?")
        throw new TypeError(`Pattern cannot start with "?" at ${r}`);
      for (; r < t.length; ) {
        if (t[r] === "\\") {
          o += t[r++] + t[r++];
          continue;
        }
        if (t[r] === ")") {
          if (u--, u === 0) {
            r++;
            break;
          }
        } else if (t[r] === "(" && (u++, t[r + 1] !== "?"))
          throw new TypeError(`Capturing groups are not allowed at ${r}`);
        o += t[r++];
      }
      if (u)
        throw new TypeError(`Unbalanced pattern at ${s}`);
      if (!o)
        throw new TypeError(`Missing pattern at ${s}`);
      n.push({ type: "PATTERN", index: r, value: o });
      continue;
    }
    n.push({ type: "CHAR", index: r, value: t[r++] });
  }
  return n.push({ type: "END", index: r, value: "" }), new we(n);
}
class we {
  constructor(t) {
    this.tokens = t, this.index = 0;
  }
  peek() {
    return this.tokens[this.index];
  }
  tryConsume(t) {
    const n = this.peek();
    if (n.type === t)
      return this.index++, n.value;
  }
  consume(t) {
    const n = this.tryConsume(t);
    if (n !== void 0)
      return n;
    const { type: r, index: a } = this.peek();
    throw new TypeError(`Unexpected ${r} at ${a}, expected ${t}: ${I}`);
  }
  text() {
    let t = "", n;
    for (; n = this.tryConsume("CHAR") || this.tryConsume("ESCAPED"); )
      t += n;
    return t;
  }
  modifier() {
    return this.tryConsume("?") || this.tryConsume("*") || this.tryConsume("+");
  }
}
class P {
  constructor(t, n) {
    this.tokens = t, this.delimiter = n;
  }
}
T.TokenData = P;
function X(e, t = {}) {
  const { encodePath: n = tt, delimiter: r = n(be) } = t, a = [], i = _e(e);
  let s = 0;
  do {
    const u = i.text();
    u && a.push(n(u));
    const o = i.tryConsume("NAME"), f = i.tryConsume("PATTERN");
    if (o || f) {
      a.push({
        name: o || String(s++),
        pattern: f
      });
      const h = i.peek();
      if (h.type === "*")
        throw new TypeError(`Unexpected * at ${h.index}, you probably want \`/*\` or \`{/:foo}*\`: ${I}`);
      continue;
    }
    if (i.tryConsume("*")) {
      a.push({
        name: String(s++),
        pattern: `(?:(?!${R(r)}).)*`,
        modifier: "*",
        separator: r
      });
      continue;
    }
    if (i.tryConsume("{")) {
      const h = i.text(), c = i.tryConsume("NAME"), d = i.tryConsume("PATTERN"), m = i.text(), p = i.tryConsume(";") && i.text();
      i.consume("}");
      const b = i.modifier();
      a.push({
        name: c || (d ? String(s++) : ""),
        prefix: n(h),
        suffix: n(m),
        pattern: d,
        modifier: b,
        separator: p
      });
      continue;
    }
    i.consume("END");
    break;
  } while (!0);
  return new P(a, r);
}
function xe(e, t = {}) {
  const n = e instanceof P ? e : X(e, t);
  return Me(n, t);
}
function Ae(e, t) {
  if (typeof e == "string")
    return () => e;
  const n = t || tt, r = e.modifier === "+" || e.modifier === "*", a = e.modifier === "?" || e.modifier === "*", { prefix: i = "", suffix: s = "", separator: u = s + i } = e;
  if (t && r) {
    const f = (c, d) => {
      if (typeof c != "string")
        throw new TypeError(`Expected "${e.name}/${d}" to be a string`);
      return n(c);
    }, h = (c) => {
      if (!Array.isArray(c))
        throw new TypeError(`Expected "${e.name}" to be an array`);
      return c.length === 0 ? "" : i + c.map(f).join(u) + s;
    };
    return a ? (c) => {
      const d = c[e.name];
      return d == null ? "" : d.length ? h(d) : "";
    } : (c) => {
      const d = c[e.name];
      return h(d);
    };
  }
  const o = (f) => {
    if (typeof f != "string")
      throw new TypeError(`Expected "${e.name}" to be a string`);
    return i + n(f) + s;
  };
  return a ? (f) => {
    const h = f[e.name];
    return h == null ? "" : o(h);
  } : (f) => {
    const h = f[e.name];
    return o(h);
  };
}
function Me(e, t) {
  const { encode: n = encodeURIComponent, loose: r = !0, validate: a = !0, strict: i = !1 } = t, s = Mt(t), u = et(r, e.delimiter), o = St(e, u, [], s, i), f = e.tokens.map((h, c) => {
    const d = Ae(h, n);
    if (!a || typeof h == "string")
      return d;
    const m = new RegExp(`^${o[c]}$`, s);
    return (p) => {
      const b = d(p);
      if (!m.test(b))
        throw new TypeError(`Invalid value for "${h.name}": ${JSON.stringify(b)}`);
      return b;
    };
  });
  return function(h = {}) {
    let c = "";
    for (const d of f)
      c += d(h);
    return c;
  };
}
function ke(e, t = {}) {
  const { decode: n = decodeURIComponent, loose: r = !0 } = t, a = e instanceof P ? e : X(e, t), i = et(r, a.delimiter), s = [], u = kt(a, s, t), o = s.map((f) => {
    if (n && (f.modifier === "+" || f.modifier === "*")) {
      const { prefix: h = "", suffix: c = "", separator: d = c + h } = f, m = new RegExp(i(d), "g");
      return (p) => p.split(m).map(n);
    }
    return n || tt;
  });
  return function(f) {
    const h = u.exec(f);
    if (!h)
      return !1;
    const { 0: c, index: d } = h, m = /* @__PURE__ */ Object.create(null);
    for (let p = 1; p < h.length; p++) {
      if (h[p] === void 0)
        continue;
      const b = s[p - 1], x = o[p - 1];
      m[b.name] = x(h[p]);
    }
    return { path: c, index: d, params: m };
  };
}
function R(e) {
  return e.replace(/([.+*?^${}()[\]|/\\])/g, "\\$1");
}
function Se(e, t) {
  const n = R(e);
  return t ? `(?:${n})+(?!${n})` : n;
}
function et(e, t) {
  if (!e)
    return R;
  const n = new RegExp(`(?:(?!${R(t)}).)+|(.)`, "g");
  return (r) => r.replace(n, Se);
}
function Mt(e) {
  return e.sensitive ? "" : "i";
}
function kt(e, t, n) {
  const { trailing: r = !0, loose: a = !0, start: i = !0, end: s = !0, strict: u = !1 } = n, o = Mt(n), f = et(a, e.delimiter), h = St(e, f, t, o, u);
  let c = i ? "^" : "";
  return c += h.join(""), r && (c += `(?:${f(e.delimiter)})?`), c += s ? "$" : `(?=${R(e.delimiter)}|$)`, new RegExp(c, o);
}
function St(e, t, n, r, a) {
  const i = `(?:(?!${R(e.delimiter)}).)+?`;
  let s = "", u = !0;
  return e.tokens.map((o, f) => {
    if (typeof o == "string")
      return s = o, t(o);
    const { prefix: h = "", suffix: c = "", separator: d = c + h, modifier: m = "" } = o, p = t(h), b = t(c);
    if (o.name) {
      const x = o.pattern ? `(?:${o.pattern})` : i, C = Te(x, o.name, r);
      if (u || (u = Z(C, h || s)), !u)
        throw new TypeError(`Ambiguous pattern for "${o.name}": ${I}`);
      if (u = !a || Z(C, c), s = "", n.push(o), m === "+" || m === "*") {
        const L = m === "*" ? "?" : "", j = t(d);
        if (!j)
          throw new TypeError(`Missing separator for "${o.name}": ${I}`);
        if (u || (u = !a || Z(C, d)), !u)
          throw new TypeError(`Ambiguous pattern for "${o.name}" separator: ${I}`);
        return u = !a, `(?:${p}(${x}(?:${j}${x})*)${b})${L}`;
      }
      return `(?:${p}(${x})${b})${m}`;
    }
    return `(?:${p}${b})${m}`;
  });
}
function Te(e, t, n) {
  try {
    return new RegExp(`^${e}$`, n);
  } catch (r) {
    throw new TypeError(`Invalid pattern for "${t}": ${r.message}`);
  }
}
function Z(e, t) {
  return t ? !e.test(t) : !1;
}
function $e(e, t = {}) {
  const n = e instanceof P ? e : X(e, t), r = [], a = kt(n, r, t);
  return Object.assign(a, { keys: r });
}
var Ce = typeof global == "object" && global && global.Object === Object && global, Ee = typeof self == "object" && self && self.Object === Object && self, Re = Ce || Ee || Function("return this")(), q = Re.Symbol;
q && q.toStringTag;
q && q.toStringTag;
var je = Function.prototype, He = je.toString;
He.call(Object);
const $ = ({
  langCode: e,
  mapper: t,
  number: n,
  keysLength: r
}) => {
  if (n === 0) return 0;
  const a = new Intl.PluralRules(e).select(n), i = t[a];
  return Math.min(
    r <= Object.keys(t).length ? i - 1 : i,
    r - 1
  );
}, De = (e, t) => $({
  langCode: "en-EN",
  mapper: { one: 1, other: 2 },
  number: e,
  keysLength: t
}), Fe = (e, t) => {
  const n = new Intl.PluralRules("ar-EG").select(e), r = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
  }[n];
  return Math.min(r, t - 1);
}, K = (e, t) => $({
  langCode: "ru-RU",
  mapper: { one: 1, few: 2, many: 3 },
  number: e,
  keysLength: t
}), Ie = (e, t) => $({
  langCode: "ro-RO",
  mapper: { one: 1, few: 2, other: 3 },
  number: e,
  keysLength: t
}), ze = (e, t) => $({
  langCode: "pl-PL",
  mapper: { one: 1, few: 2, many: 3 },
  number: e,
  keysLength: t
}), Pe = (e, t) => $({
  langCode: "is-IS",
  mapper: { one: 1, other: 2 },
  number: e,
  keysLength: t
}), Le = (e, t) => $({
  langCode: "hr-HR",
  mapper: { one: 1, few: 2, other: 3 },
  number: e,
  keysLength: t
}), Oe = (e, t) => $({
  langCode: "cs-CZ",
  mapper: { one: 1, few: 2, other: 3 },
  number: e,
  keysLength: t
}), k = () => 0, Ne = {
  ar: Fe,
  cs: Oe,
  hr: Le,
  id: k,
  is: Pe,
  ja: k,
  ko: k,
  lt: K,
  pl: ze,
  ro: Ie,
  ru: K,
  uk: K,
  th: k,
  vi: k,
  zh: k,
  "zh-TW": k
};
function Be(e, t, n, r, a) {
  const u = (Ne[e || "en"] ?? De)(t, 2);
  return !u && a === "lastReservation" ? n.replace(r.hours, r.hour) : !u && ["nowViewing", "todayViewed", "bookedToday"].includes(a) ? n.replace(r.people, r.person) : n;
}
function W(e) {
  const t = /^(&|&amp;|a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|v.?|vs.?|via)$/i, n = /([A-Za-z0-9\u00C0-\u00FF])/, r = /([ :–—-])/;
  return e.split(r).map((a, i, s) => a.search(t) > -1 && i !== 0 && i !== s.length - 1 && s[i - 3] !== ":" && s[i + 1] !== ":" && (s[i + 1] !== "-" || s[i - 1] === "-" && s[i + 1] === "-") ? a.toLowerCase() : a.substring(1).search(/[A-Z]|\../) > -1 || s[i + 1] === ":" && s[i + 2] !== "" ? a : a.replace(n, (u) => u.toUpperCase())).join("");
}
function Ve(e, t) {
  switch (e) {
    case "opacity":
      return (parseInt(t, 10) / 100).toString();
    case "thickness":
      return ge(parseInt(t, 10));
    case "cssName":
      return `'${t}'`;
    default:
      return t;
  }
}
function Ue(e, t) {
  switch (e) {
    case "cornerRadius":
      return de(t);
    case "padding":
      return pe(t);
    default:
      return null;
  }
}
function Tt(e, t) {
  return Object.keys(e).reduce((n, r) => {
    var i;
    let a = Ve(r, (i = e[r]) == null ? void 0 : i.toString());
    return me(e[r]) && (a = Ue(r, e[r]), !a) ? {
      ...n,
      ...Tt(e[r], `${t}-${wt(r)}`)
    } : (n[`${t}-${wt(r)}`] = a, n);
  }, {});
}
class qe {
  constructor() {
    M(this, "rootDom", null);
    M(this, "state", z({
      colors: {},
      fonts: {},
      button: {},
      background: {},
      secondaryButton: {},
      overlay: {}
    }));
  }
  get rootElement() {
    return this.rootDom;
  }
  get fonts() {
    return this.state.fonts;
  }
  get backgroundImage() {
    var t, n;
    return (n = (t = this.state.background.image) == null ? void 0 : t.urls) == null ? void 0 : n.edited;
  }
  get backgroundImageAlt() {
    var t;
    return (t = this.state.background.image) == null ? void 0 : t.alt;
  }
  get colors() {
    return this.state.colors;
  }
  get button() {
    return this.state.button;
  }
  initialize(t, n) {
    var i, s, u, o, f, h, c, d, m, p, b, x, C, L, j, nt, rt, at, it, st, ot, ut, lt, ct;
    this.rootDom = n, this.state.colors = t.colors || {}, this.state.fonts = {
      ...t.fonts,
      perks: ((i = t.fonts) == null ? void 0 : i.perks) ?? ((s = t.fonts) == null ? void 0 : s.other),
      countdown: ((u = t.fonts) == null ? void 0 : u.countdown) ?? ((o = t.fonts) == null ? void 0 : o.other)
    }, this.state.button = t.button || {}, this.state.secondaryButton = t.secondaryButton || {}, this.state.background = t.background || {}, this.state.overlay = t.overlay || {}, t.syncButtonStyles === void 0 && (this.state.secondaryButton = this.state.button, this.state.colors.secondaryButtonText = this.state.colors.buttonText, this.state.colors.secondaryButtonBackground = this.state.colors.buttonBackground, this.state.fonts.secondaryButton = this.state.fonts.button);
    const r = l(((f = this.state.colors.background) == null ? void 0 : f.base) ?? "#FFF"), a = Tt(this.state, "--thn-tool");
    this.addCssVariables({
      ...a,
      "--thn-tool-colors-icon-back": fe(((h = t.colors) == null ? void 0 : h.icon) || "#000000", 0.15),
      "--thn-tool-colors-background": (d = (c = t.colors) == null ? void 0 : c.background) != null && d.gradient ? `linear-gradient(to right bottom, ${(p = (m = t.colors) == null ? void 0 : m.background) == null ? void 0 : p.base}, ${(x = (b = t.colors) == null ? void 0 : b.background) == null ? void 0 : x.gradient})` : (L = (C = t.colors) == null ? void 0 : C.background) == null ? void 0 : L.base,
      "--thn-tool-button-background-color": ((j = t.button) == null ? void 0 : j.style) === O.Solid ? (nt = t.colors) == null ? void 0 : nt.buttonBackground : "transparent",
      "--thn-tool-button-border": ((rt = t.button) == null ? void 0 : rt.style) === O.Outline ? `solid 2px ${(at = t.colors) == null ? void 0 : at.buttonBackground}` : "transparent",
      "--thn-tool-secondary-button-background-color": ((it = this.state.secondaryButton) == null ? void 0 : it.style) === O.Solid ? (st = this.state.colors) == null ? void 0 : st.secondaryButtonBackground : "transparent",
      "--thn-tool-secondary-button-border": ((ot = this.state.secondaryButton) == null ? void 0 : ot.style) === O.Outline ? `solid 2px ${(ut = this.state.colors) == null ? void 0 : ut.secondaryButtonBackground}` : "transparent",
      "--thn-tool-background-border": (ct = (lt = t.background) == null ? void 0 : lt.border) != null && ct.color ? `solid ${a["--thn-tool-background-border-thickness"]} ${t.background.border.color}` : "none",
      "--thn-tool-focus-visible": r.isLight() ? "#767676" : "#ADADAD"
    });
  }
  addCssVariables(t) {
    Object.keys(t).forEach((n) => {
      var r;
      (r = this.rootDom) == null || r.style.setProperty(n, t[n] || "");
    });
  }
  getCssVariableValue(t) {
    return this.rootDom && getComputedStyle(this.rootDom).getPropertyValue(t);
  }
}
const Ge = (e, t, n) => {
  const r = e[t];
  return r ? typeof r == "function" ? r() : Promise.resolve(r) : new Promise((a, i) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
      i.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + t + (t.split("/").length !== n ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
};
class Xe {
  constructor() {
    M(this, "state", z({
      language: S.English,
      device: J.Desktop,
      literals: {}
    }));
  }
  get device() {
    return this.state.device;
  }
  get language() {
    return this.state.language;
  }
  async initialize(t, n) {
    this.state.language = t ?? S.English, this.state.device = n ?? J.Desktop;
    const r = await Ge(/* @__PURE__ */ Object.assign({ "../locales/ar.json": () => import("./ar.Wv4oTDtZ.js"), "../locales/bg.json": () => import("./bg.B4GYjJSd.js"), "../locales/ca.json": () => import("./ca.Q-LZDm9_.js"), "../locales/cs.json": () => import("./cs.BbiDS9M6.js"), "../locales/da.json": () => import("./da.B_wXMnz6.js"), "../locales/de.json": () => import("./de.CsetPALd.js"), "../locales/el.json": () => import("./el.DHHUKWLw.js"), "../locales/en.json": () => import("./en.3kjegigf.js"), "../locales/es.json": () => import("./es.DANaCrW0.js"), "../locales/et.json": () => import("./et.Dw-hqfsy.js"), "../locales/eu.json": () => import("./eu.CQCeHw9K.js"), "../locales/fi.json": () => import("./fi.BaeQSZI9.js"), "../locales/fr.json": () => import("./fr.DpWKb8Ln.js"), "../locales/he.json": () => import("./he.D0nViRhb.js"), "../locales/hr.json": () => import("./hr.DR0Ump6x.js"), "../locales/hu.json": () => import("./hu.HZNRCsVl.js"), "../locales/id.json": () => import("./id.BIkX4WZC.js"), "../locales/is.json": () => import("./is.DYhu72Ih.js"), "../locales/it.json": () => import("./it.CKUeX7yx.js"), "../locales/ja.json": () => import("./ja.-RRD7DzA.js"), "../locales/ko.json": () => import("./ko.IbfK3_7x.js"), "../locales/lt.json": () => import("./lt.CJdZFPsA.js"), "../locales/nl.json": () => import("./nl.fkLpaJ4v.js"), "../locales/no.json": () => import("./no.sqn5c5eM.js"), "../locales/pl.json": () => import("./pl.Kv395zEs.js"), "../locales/pt.json": () => import("./pt.2Ty0oUZr.js"), "../locales/ro.json": () => import("./ro.BSunRZJf.js"), "../locales/ru.json": () => import("./ru.BWPiDBOw.js"), "../locales/sk.json": () => import("./sk.D_qKoQn4.js"), "../locales/sl.json": () => import("./sl.BT0LeboW.js"), "../locales/sv.json": () => import("./sv.C-Nv17eD.js"), "../locales/th.json": () => import("./th.CDpBzJ5t.js"), "../locales/tr.json": () => import("./tr.CzbuKf4n.js"), "../locales/uk.json": () => import("./uk.FADYOFGn.js"), "../locales/vi.json": () => import("./vi.CE5F6H_Y.js"), "../locales/zh-TW.json": () => import("./zh-TW.Bhjn5afO.js"), "../locales/zh.json": () => import("./zh.C7CxJfgs.js") }), `../locales/${this.state.language}.json`, 3);
    this.state.literals = r.default;
  }
  getLiteral(t, n) {
    return n ? W(this.state.literals[t] || t) : this.state.literals[t] || t;
  }
  getLiteralAbb(t, n) {
    const r = `${t}_abbr`;
    return this.getLiteral(r, n);
  }
  getActivityLiteral(t, n = {}) {
    const r = n[t], a = Be(
      this.state.language,
      Number(r),
      this.state.literals[Ft[t]],
      this.state.literals,
      t
    );
    return r ? a == null ? void 0 : a.replace("XXXXXX", r) : a;
  }
  getPerkActiveLiteral(t, n = !1) {
    const r = t[this.state.language] ?? "";
    return n ? W(r) : r;
  }
  getPerkTooltipLiteral(t) {
    return this.state.literals[It[t]];
  }
  getActiveModuleText(t, n = !1, r) {
    let a = t[this.device][this.language] ?? "";
    if (r) {
      const { candidates: i = [], replacement: s = {} } = r;
      i.forEach((u) => {
        const o = s[u];
        if (!o)
          throw Error("The tool cannot be shown if any of the tokens do not have a correct replacement value");
        a = a.replaceAll(`{${u}}`, o);
      });
    }
    return n ? W(a) : a;
  }
  getLocaleImageUrl(t) {
    var n;
    switch (t.languageType) {
      case N.Multi:
        return (n = t.urls[this.language || S.English]) == null ? void 0 : n.edited;
      case N.Single:
      default:
        return t.urls.edited;
    }
  }
  getLocaleImageAlt(t) {
    switch (t.languageType) {
      case N.Multi:
        return t.alt[this.language || S.English];
      case N.Single:
      default:
        return t.alt;
    }
  }
}
class Ze {
  constructor() {
    M(this, "initTime", Date.now());
    M(this, "state", z({
      builderMode: !1,
      firstVisitDate: null,
      hotelTimezone: "Europe/Madrid",
      defaultAssets: void 0,
      countdownTimestamp: void 0,
      tokens: {},
      dynamicTags: []
    }));
  }
  get countdownInitTime() {
    return this.initTime;
  }
  get builderMode() {
    return this.state.builderMode;
  }
  get defaultAssets() {
    return this.state.defaultAssets;
  }
  get countdownTimestamp() {
    return this.state.countdownTimestamp;
  }
  get tokens() {
    return this.state.tokens;
  }
  get dynamicTags() {
    return this.state.dynamicTags;
  }
  initialize(t) {
    this.state.builderMode = !!t.builderMode, this.state.firstVisitDate = t.firstVisitDate, this.state.hotelTimezone = t.hotelTimezone, this.state.hotelTimezoneOffset = t.hotelTimezoneOffset, this.state.defaultAssets = t.defaultAssets, this.state.countdownTimestamp = t.countdownTimestamp, this.state.tokens = t.tokens, this.state.dynamicTags = t.dynamicTags;
  }
  getCountdownTimestamp(t, n) {
    const {
      date: r = Date.now(),
      timezone: a,
      days: i = 0,
      hours: s = 0,
      minutes: u = 0
    } = n;
    if (this.initTime = Date.now(), t === gt.Time) {
      const o = i * 24 * 60 * 60 * 1e3, f = s * 60 * 60 * 1e3, h = u * 60 * 1e3, c = this.state.firstVisitDate ? this.initTime - this.state.firstVisitDate : 0;
      return this.initTime + o + f + h - c;
    }
    if (t === gt.Date && r) {
      const o = new Date(r);
      if (o.setHours(s), o.setMinutes(u), a === zt.Hotel)
        if (!this.state.hotelTimezoneOffset && this.state.hotelTimezone) {
          const f = (/* @__PURE__ */ new Date()).toLocaleString("en-US", {
            timeZone: this.state.hotelTimezone
          }), c = new Date(f).getTime() - (/* @__PURE__ */ new Date()).getTime();
          o.setTime(o.getTime() - c);
        } else this.state.hotelTimezoneOffset && o.setTime(o.getTime() - this.state.hotelTimezoneOffset);
      return o.getTime();
    }
    return null;
  }
}
const $t = new Xe(), Ct = {}, Et = {};
function Rt() {
  const e = Y();
  return (e == null ? void 0 : e.uid) || 0;
}
function Ke() {
  var t;
  const e = Y();
  return (t = e == null ? void 0 : e.proxy) == null ? void 0 : t.$el;
}
function We(e) {
  var r;
  const t = Y(), n = (r = t == null ? void 0 : t.exposed) == null ? void 0 : r.hide;
  e.inited = !0, e.hideFunction = n || (() => {
  });
}
function Je(e) {
  const t = Rt(), n = Ke(), r = Ct[t];
  if (r.inited)
    r.language = e.language, r.rtl = e.language === S.Arabic || e.language === S.Hebrew, r.device = e.device, r.extraData.initialize(e.extraData), r.handlers.initialize(r.hideFunction, e.actions), r.literals.initialize(e.language, e.device), r.styles.initialize(e.styles, n);
  else
    throw new Error(`error updating store ${t}: store not inited`);
}
function un(e) {
  const t = Rt(), n = Symbol("useStore injection key"), r = z({
    uid: t,
    inited: !1,
    language: S.English,
    device: J.Desktop,
    hideFunction: () => {
    },
    extraData: new Ze(),
    handlers: new Nt(),
    literals: $t,
    styles: new qe()
  });
  return Ct[t] = r, Et[t] = n, ht(n, r), ht("rootUID", t), Dt(() => {
    We(r), Je(e);
  }), r;
}
function ln() {
  const e = ft("rootUID");
  if (e !== void 0)
    return ft(Et[e]);
  throw new Error("No UID found to load the store");
}
function cn() {
  return $t;
}
export {
  D as B,
  Ge as _,
  en as a,
  wt as b,
  nn as c,
  de as d,
  ge as e,
  rn as f,
  Be as g,
  fe as h,
  an as i,
  pe as j,
  me as k,
  sn as l,
  W as m,
  un as n,
  ln as o,
  V as p,
  cn as q,
  on as s,
  l as t,
  Je as u
};
//# sourceMappingURL=useStore.DvPy8fc7.js.map
